import React from 'react'
import translations from "../../../utils/language/translations.json";
import { useTranslation } from "react-i18next";

const Security = () => { 
    const { t: translate, i18n } = useTranslation();
  const currentLang = i18n.language;
  const t = (key) => translations.FooterSecurity[key][currentLang];
  return (
    <section className='grid'> 
    <div className="contentfront">

    <div className="page-content security-page">
      <h1>{t("title")}</h1>

      <p>{t("intro")}</p>

      <div className="highlight-box">
        <h2>{t("tipsTitle")}</h2>
        <ul className='styled-bullets'>
          <li>✅ {t("tip1")}</li>
          <li>📷 {t("tip2")}</li>
          <li>🤝 {t("tip3")}</li>
          <li>🔎 {t("tip4")}</li>
        </ul>
      </div>

      <p>{t("finalNote")}</p>
    </div>



    </div>
    </section>
  )
}

export default Security